import React, { useState, useContext, useEffect } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/brandValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { BrandContext } from "../brand";

axios.defaults.baseURL = API;

function CreateBrand(props) {

    const {dataList, setDataList, ProductTypeList, CategoryList, setShowData} = useContext(BrandContext);
    const [categoryData, setCategoryData] = useState([]);
    
    const handleInputPaymentTypeChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.Brand.toLowerCase() === params.toLowerCase() &&
                   data.CategoryID === values.CategoryID
        });
        if (results.length > 0)
            handleChange("CheckBrand", results[0].Brand);
        else
            handleChange("CheckBrand", "");
    }

    const handleSelectProductType = (e) => {
        const { value } = e.target;
        if(value){
            getCategoryByProductTypeID(e.target.children[e.target.selectedIndex].getAttribute('data-id'));
            handleChange("ProductType", value);
            handleChange("ProductTypeID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("ProductType", "");
            handleChange("ProductTypeID", "");
            handleChange("Category", "");
            handleChange("CategoryID", "");
            handleChange("Brand", "");
        }
        
    };

    async function getCategoryByProductTypeID(value) {
        let token = localStorage.getItem("token");
        await axios.get(`/getCategoryByProductTypeID/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
          let temOrder = response?.data;
          if(temOrder.length > 0){
            setCategoryData(temOrder);
          } else {
            setCategoryData([]);
          }
        }).catch((err) => {
            setCategoryData([]);
            console.log(err);
        });
    }

    const handleSelectCategory = (e) => {
        var data = categoryData.filter(function (item) {
            return item.Category == e.target.value
        })
        if (data.length > 0) {
            handleChange("Category", data[0].Category);
            handleChange("CategoryID", data[0].CategoryID);
        } else {
            handleChange("Category", "");
            handleChange("CategoryID", "");
            handleChange("Brand", "");
        }
    };

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            ProductTypeID: values.ProductTypeID,
            CategoryID: values.CategoryID,
            Brand: values.Brand,
        }
        await axios.post("/createBrand", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getAllBrand();
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getAllBrand() {
        axios
          .get("/getAllBrand")
          .then((response) => {
            let Data = response?.data;
            setDataList(Data);
            setShowData(Data);
          })
          .catch((error) => {
            console.log(error);
          });
      }

    const ClearData = () => {
        handleChange("ProductTypeID", "");
        handleChange("ProductType", "");
        handleChange("CategoryID", "");
        handleChange("Category", "");
        handleChange("BrandID", "");
        handleChange("Brand", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ສ້າງຫຍີ່ຫໍ້</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ປະເພດສິນຄ້າ: </label>
                                <select name="ProductTypeID" onChange={(e) => handleSelectProductType(e)}
                                    className={`input form-control ${errors.ProductTypeID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກປະເພດສິນຄ້າ'}
                                    </option>
                                    {   ProductTypeList && ProductTypeList.map(item => (
                                        <option
                                            key={item.ProductTypeID}
                                            data-id={item.ProductTypeID}
                                            value={item.ProductTypeID}
                                        >
                                            {item.ProductType}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>ໝວດສິນຄ້າ: </label>
                                <select name="CategoryID" onChange={(e) => handleSelectCategory(e)}
                                    className={`input form-control ${errors.CategoryID && 'is-invalid'}`} disabled={!values.ProductTypeID}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກໝວດສິນຄ້າ'}
                                    </option>
                                    {   categoryData && categoryData.map(item => (
                                        <option
                                            key={item.CategoryID}
                                            value={item.Category}
                                        >
                                            {item.Category}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ຫຍີ່ຫໍ້</span>
                                <input className={`input form-control ${errors.Brand && 'is-invalid'}`} type="text" name="Brand" onChange={(e) => handleInputPaymentTypeChange(e)} value={values.Brand || ''} required disabled={!values.CategoryID} />
                                {errors.Brand && (
                                    <p className="invalid-feedback">{errors.Brand}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateBrand;
